export default __webpack_public_path__ + "static/media/car-info.c5ba8bd1.png";